import { useState } from 'react';

import { Alert } from 'react-bootstrap';
import { useIntl } from 'react-intl';

interface IErrorProps {
  retry?: any;
  errorMessage?: any;
  dismissible?: boolean;
  className?: string;
  onClose?: any;
  children?: React.ReactChild;
  dataTestId?: string;
}

const Error = ({
  retry,
  errorMessage,
  dismissible,
  className,
  onClose,
  children,
  dataTestId
}: IErrorProps) => {
  const intl = useIntl();
  const [visible, setVisible] = useState(true);
  const message = errorMessage || `${intl.formatMessage({ id: 'errorKey' })}. `;

  const onCloseEvent = () => {
    if (onClose) {
      onClose();
    } else {
      setVisible(false);
    }
  };

  return (
    <>
      {visible && (
        <Alert
          data-test={dataTestId}
          variant="danger"
          onClose={onCloseEvent}
          dismissible={dismissible !== false}
          className={`${className} d-flex ${children ? 'align-items-start' : 'align-items-center'}`}
        >
          {message}
          {retry && (
            <div>
              <a onClick={retry} className="ms-1 cursor-pointer">
                {intl.formatMessage({ id: 'tryAgainKey' })}
              </a>
              {'. '}
              <span>{intl.formatMessage({ id: 'ifPersistKey' })}</span>
            </div>
          )}
          {children}
        </Alert>
      )}
    </>
  );
};

export default Error;
